<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="share"
    title="Переслать сообщение"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <div class="container-fluid pt-5">
        <h6 class="text-muted">
          Выберите кому переслать
          <a class="pointer text-primary" (click)="modalService.openModal('ModalMessagePinnedComponent', {
      messages: messages,
      Service: this.Service,
      title: 'Пересылаемые сообщения'
    });">{{ messages?.length | declination: ['cообщение', 'cообщения', 'cообщений'] }}</a>
        </h6>
        <app-contacts-list
          [scroll]="scroll"
          [sort]="'chats'"
          [source]="'chats'"
          [isCheckbox]="false"
          [search]="'local'"
          (onToggleUser)="toggleUser($event)"
          [Service]="Service"
        ></app-contacts-list>
      </div>
    </div>
  </div>
</div>